import React, { useContext } from 'react';
import ivclass from '@invideoio/web-shared/Modules/IVClass';
import { isUserLoggedIn } from '@utils/common.utils';
import { sendAmplitudeAnalyticEvent, AmplitudeEvents } from '@utils/analytics';
import { RedirectContext } from '@store/store';
import { AUTH_TYPE } from '@constants/homepage';

function AffiliteHero({ heroSection, platform, theme = 'dark' }: any) {
  const { handleClick } = useContext(RedirectContext);

  const handleCtaClick = () => {
    if (!isUserLoggedIn()) {
      sendAmplitudeAnalyticEvent(AmplitudeEvents.clickSignUp, {
        btnPosition: 'Affiliate Offer',
      });
    }

    handleClick('', { tab: AUTH_TYPE.SIGNUP });
  };

  return (
    <div
      className={ivclass(
        'iv-relative iv-container iv-m-auto iv-px-40 iv-py-150 md:iv-py-100 sm:iv-py-75',
        'iv-flex md:iv-flex-col sm:iv-flex-col',
        heroSection.mainVideo ? 'iv-justify-around' : 'iv-justify-start',
      )}
      style={{
        backgroundImage:
          platform === 'mobile'
            ? `url(${heroSection.mainBgImg.mobile})`
            : `url(${heroSection.mainBgImg.desktop})`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
      }}
    >
      <div
        className={ivclass(
          'iv-z-10 iv-max-w-lg',
          theme === 'dark' && 'iv-text-grey-0 ',
        )}
      >
        <div className={ivclass('iv-mb-20')}>
          <h1
            className={ivclass(
              'iv-text-heading-m md:iv-m-heading-xs sm:iv-text-heading-2xs iv-font-semibold',
            )}
          >
            {heroSection.title}
          </h1>
        </div>
        <div className={ivclass('iv-text-body-3xl', 'iv-mb-20')}>
          {heroSection.subTitle}
        </div>
        <div
          className={ivclass(
            'iv-border iv-rounded-10 iv-max-w-xs',
            theme === 'dark' ? 'iv-border-grey-0' : 'iv-border-grey-100',
            'iv-text-center iv-font-semibold',
          )}
        >
          <div className={ivclass('iv-p-20')}>
            {heroSection.offerSubTitle && (
              <div>{heroSection.offerSubTitle}</div>
            )}
            <div className={ivclass('iv-text-heading-xs iv-pb-15')}>
              {heroSection.offerTitle}
            </div>
          </div>
          <button
            className={ivclass(
              'iv-w-full iv-rounded-b-lg',
              'iv-py-10 iv-px-15',
              'iv-font-semibold',
              theme === 'dark'
                ? 'iv-text-grey-85 iv-bg-grey-0'
                : 'iv-text-grey-0 iv-bg-grey-100',
            )}
            type="button"
            onClick={handleCtaClick}
          >
            {heroSection.getOfferTxt}
          </button>
        </div>
      </div>
      {heroSection.mainVideo && (
        <div className="iv-flex iv-items-center iv-justify-center md:iv-mt-50 sm:iv-mt-50">
          <video
            loop
            muted
            playsInline
            autoPlay
            className="iv-max-w-xs iv-rounded-lg"
          >
            <source type="video/mp4" src={heroSection.mainVideo.src} />
          </video>
        </div>
      )}
    </div>
  );
}

export default AffiliteHero;
